export default __webpack_public_path__ + "static/media/2412.fca49624.png";